import useAxiosService from './useAxiosService'
import { IResponse } from 'interfaces/services'
import {
  IBooking,
  IBookingQuery,
  ICancelBookingQuery
} from 'pages/patientBooking/interfaces'
import { IPatient } from 'pages/patientReceive/interfaces'

export const useBookingServices = () => {
  const { post, get } = useAxiosService()

  const cancelBooking = async (
    query: ICancelBookingQuery
  ): Promise<IResponse<Array<IBooking>>> => {
    const response: any = await post('/clinic/booking/cancel', query)
    return {
      ...response,
      data: response.data?.bookings
    } as IResponse<Array<IBooking>>
  }

  const searchBooking = async (query: IBookingQuery) => {
    const response = await post('/clinic/booking/search', query)
    return response as IResponse<{
      bookings: Array<IBooking>
      total_items: number
    }>
  }

  const getPatientById = async (patientId: number | string) => {
    const response = await get(`/clinic/patient/${patientId}`)
    return response as IResponse<IPatient>
  }

  const countBookings = async (roomId: any) => {
    const response = await post('/clinic/booking/count-bookings', roomId)
    return response as IResponse<any>
  }
  return { cancelBooking, searchBooking, getPatientById, countBookings }
}
